import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {useTheme} from "../../contexts/theme";
import {useMamInformation} from "../../contexts/MamInformation";
import {useMamSummary} from "../../contexts/mamSummary";
import EventMam from "./EventMam";
import {useEffect, useState} from "react";
import {MatchDays} from "../../types/mamTypes";
import axiosInstance from "../../queries/axiosInstance";
import {result} from "lodash";
import {useActiveFilters} from "../../contexts/activeFilters";
import {getGroupClips} from "../../queries/mamPageQueries";
import {clipGroupPageSize} from "../../utils/constants";
import MatchDaysMamSkeleton from "./MamSkeleton/MatchDaysMamSkeleton";
import {markEditedGroupClips} from "../../utils/utilsClip";
import {useSSEProvider} from "../../contexts/SSEProvider";


interface MatchContainerProps {
    matchDay: MatchDays
    loading: boolean
}


export default function MatchContainer({matchDay, loading}: MatchContainerProps){
    const { jobsRunning } = useSSEProvider();

    const {information} = useMamInformation();
    const {setInformation, setUpdateLoading} = useMamInformation();

    const {activeFilters} = useActiveFilters();

    const {summary} = useMamSummary();
    const {setSummary} = useMamSummary();

    const [loadingGroupClips, setLoadingGroupClips] = useState<boolean>(false);


    const theme = useTheme();

    const [openEvents, setOpenEvents] = useState<Set<string>>(new Set<string>());

    const getClipsOnDemand = async (competition: string, matchday: string, event_id: string) => {
        try {
            setUpdateLoading(true);
            return await getGroupClips(competition, matchday, event_id, activeFilters,0, clipGroupPageSize)
        } catch (errorCompetition) {
            console.error("Error retrieve events", JSON.stringify(errorCompetition));
        }finally {
            setUpdateLoading(false);
        }
    }

    const onCollapseEventOpen = (competition: string, matchDay_id: string, event_id: string, openEvent: boolean) => {
        const tempSummary = {...summary};


        if (openEvent){
            tempSummary.match = tempSummary.match.filter(item => item !== ""+event_id);
        }else {
            if (!tempSummary.match.find(item => item === event_id)) {
                const match = [...tempSummary.match];
                match.push(event_id);
                tempSummary.match = match;
            }
            setLoadingGroupClips(true);
            getClipsOnDemand(competition, matchDay_id, event_id).then(response => {
                const tempInformation = {...information!};

                if (tempInformation.clipGroups) {
                    for(const clipGroup of response) {
                        if(!information?.clipGroups.find(cp => cp.id === clipGroup.id)) {
                            tempInformation.clipGroups!.push(clipGroup);
                        }
                    }
                    // response.map((item: any) => {
                    //     if (!tempInformation.clipGroups!.includes(item)) {
                    //         tempInformation.clipGroups!.push(item);
                    //     }
                    // })
                    tempInformation.clipGroups = markEditedGroupClips(jobsRunning, tempInformation.clipGroups).clipGroups
                    setInformation(tempInformation)
                }


            setLoadingGroupClips(false)
            })


        }
        setSummary(tempSummary);
        const tempOpenEvents = new Set<string>(openEvents);
        tempOpenEvents.add(event_id);
        setOpenEvents(tempOpenEvents);
    }






    return (
        <Box>

            { (loading && (!information?.matchDayEvents.find(item => item.matchDayId === matchDay.id)) ) ?
                (
                    <MatchDaysMamSkeleton  skeletonNumber={15} />
                ) : (
                    information?.matchDayEvents
                        ?.filter(event => event.matchDayId === matchDay.id) // <-- qui è la chiave
                        ?.map((event, eventIndex) => (
                            <Grid
                                key={`${event.id}-${eventIndex}`} // Se due eventi avessero lo stesso id, eviti errori con index
                                item
                                xs={12}
                                lg={6}
                                sx={{
                                    borderBottom: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}`,
                                    backgroundColor: theme.palette.blurredBlue,
                                    paddingTop: theme.spacing.sm,
                                    paddingBottom: theme.spacing.sm,

                                }}
                            >
                                <EventMam collapseOpen={Boolean(summary.match.find(eventId => event.id === eventId))} entity={event} onCollapseEventOpen={onCollapseEventOpen} loadingGroupClips={loadingGroupClips}/>
                            </Grid>
                        ))

                )

            }


        </Box>
    );
}